import type { TextFieldProps } from "@mui/material";
import { Box } from "@mui/material";
import { MuiColorInput } from "mui-color-input";
import { type FieldErrorProps, useFieldError } from "Hooks/useFieldError";

type Props = Omit<TextFieldProps, "value" | "onChange"> &
  FieldErrorProps & {
    value?: string | null;
    onChange?: (value: string) => void;
    label?: string;
    name?: string;
    helperText?: string;
    placeholderColor?: string;
  };

export const ColorInput = (props: Props) => {
  const { hasError, errorMessage, originalProps } = useFieldError(props);

  const {
    value,
    onChange,
    label,
    name,
    helperText,
    placeholderColor,
    ...rest
  } = originalProps;

  return (
    <Box display="flex" flexDirection="column">
      <div>{label && <label htmlFor={name}>{label}</label>}</div>
      <Box position="relative">
        <MuiColorInput
          format="hex"
          value={value || placeholderColor || ""}
          onChange={onChange}
          helperText={hasError ? errorMessage : helperText}
          error={hasError}
          fullWidth
          sx={({ spacing, colors }) => ({
            marginTop: spacing(1),
            "& .MuiInputBase-root": { minHeight: "44px" },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.border,
            },
          })}
          {...rest}
        />
      </Box>
    </Box>
  );
};
